import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import { SummaryContainer } from './css';

import AccessoriesTracker from './accessoriesTracker';
import PowerFleetTracker from './coldChainMonitorCard';

const SummaryTrackerPowerFleet = ({
  rateplanList,
  ratePlans,
  hardwarePowerFleet,
  monthlySoftwareSubscription,
  professionalServices,
  hardwareColdChainPowerFleet,
  professionalServicesColdChain
}) => {

  const [hardwareModel, setHardwareModel] = useState();
  const [hardwareList, setHardwareList] = useState();

  const [tracker, setTracker] = useState({
    fleetTrackerRateplanTotal: 0
  });

  useEffect(() => {
    const hardwareTotalList = rateplanList.reduce((acc, current) => {
      if (!_.get(current, 'fields.isHeader', false)) {
        const rateplanType = _.get(current, 'fields.rateplanType', '');
        const devicesList = _.get(current, 'fields.deviceList', []).reduce(
          (deviceAcc, deviceCurrent) => {
            return {
              ...deviceAcc,
              [_.get(deviceCurrent, 'fields.deviceName', '')]: 0
            };
          },
          {}
        );
        return {
          ...acc,
          [rateplanType]: { ...acc[rateplanType], ...devicesList }
        };
      }
      return { ...acc };
    }, {});
    setHardwareModel(hardwareTotalList);
  }, []);

  useEffect(() => {
    if (hardwareModel) {
      let totalRateplanFleetTracker = 0;
      const hardwareObj =
        hardwareModel &&
        Object.keys(hardwareModel).reduce((acc, currentRateplanType) => {
          const deviceList = Object.keys(
            hardwareModel[currentRateplanType]
          ).reduce(
            (deviceAcc, currentDevice) => ({
              ...deviceAcc,
              [currentDevice]: 0
            }),
            {}
          );
          return { ...acc, [currentRateplanType]: { ...deviceList } };
        }, {});
      /**
       * Calculating Rateplan total + included hardware count
       */
      Object.keys(ratePlans).forEach(plan => {
        Object.keys(ratePlans[plan]).forEach(device => {
          const ratePlanQuantity = ratePlans[plan][device].quantity || 0;
          const ratePlanType = Object.keys(hardwareObj).reduce(
            (acc, current) => {
              if (device in hardwareObj[current]) return current;
              return acc;
            },
            ''
          );

        //   if (_.get(hardwareObj, `${ratePlanType}.${device}`, false))
            hardwareObj[ratePlanType][device] += ratePlanQuantity;
          totalRateplanFleetTracker +=
            ratePlanType === 'Fleet Tracker' ? ratePlanQuantity : 0;
        });
      });

      setTracker({
        fleetTrackerRateplanTotal: totalRateplanFleetTracker
      });

      setHardwareList(hardwareObj);
    }

  }, [hardwareModel, ratePlans]);

  return (
    <>
      {hardwareList && (
        <SummaryContainer>
          {_.get(hardwareList, 'Fleet Tracker', '') && (
            <PowerFleetTracker
              tracker={tracker}
              hardwareList={_.get(hardwareList, 'Fleet Tracker', {})}
            />
          )}
          <AccessoriesTracker hardware={hardwarePowerFleet} sectionText='Hardware'/>
          <AccessoriesTracker hardware={monthlySoftwareSubscription} sectionText='Monthly Software Subscription'/>
          <AccessoriesTracker hardware={professionalServices} sectionText='Professional Services'/>
          {/* <AccessoriesTracker hardware={hardwareColdChainPowerFleet} sectionText='Hardware Cold Chain'/> */}
          {/* <AccessoriesTracker hardware={professionalServicesColdChain} sectionText='Professional Services Cold Chain'/> */}
        </SummaryContainer>
      )}
    </>
  );
};

SummaryTrackerPowerFleet.propTypes = {
  rateplanList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  ratePlans: PropTypes.shape({}).isRequired,
  hardware: PropTypes.shape({}).isRequired,
  hardwarePowerFleet: PropTypes.shape({}).isRequired,
  monthlySoftwareSubscription: PropTypes.shape({}).isRequired,
  professionalServices: PropTypes.shape({}).isRequired,
  hardwareColdChainPowerFleet: PropTypes.shape({}).isRequired,
  professionalServicesColdChain: PropTypes.shape({}).isRequired
};

export default SummaryTrackerPowerFleet;
